import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';

import { SharedUiFormElementsCountrySelectListModule } from '../../shared-ui-form-elements-country-select-list.module';
import { fetchCountryList } from '../../store/country.actions';
import { selectCountryList } from '../../store/country.selectors';

@Component({
  selector: 'offconon-all-country-multi-select-list',
  templateUrl: './all-country-multi-select-list.component.html',
  styleUrls: ['./all-country-multi-select-list.component.scss'],
  imports: [
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AsyncPipe,
    TranslateModule,
    SharedUiFormElementsCountrySelectListModule,
  ],
})
export class AllCountryMultiSelectListComponent {
  @Input({ required: true }) locationFormControl: FormControl;
  private store$ = inject(Store);

  countryList$ = this.store$.select(selectCountryList);
  constructor() {
    this.store$.dispatch(fetchCountryList());
  }
}
